module.exports = __webpack_public_path__ + "static/media/KMH_5303.b7fa0200.jpg";